import styled, { css } from 'styled-components'

export const Container = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  padding: ${props => props.theme.spacing.sp4} ${props => props.theme.spacing.sp8};
  height: ${props => props.theme.spacing.sp32};
  border-radius: 6px;
  cursor: pointer;
  background-color: transparent;
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  & > p:first-of-type {
    color: ${props => props.theme.colors.text.default};
  }

  & > p:last-of-type {
    color: ${props => props.theme.colors.text.muted};
  }

  &:hover {
    border-color: ${props => props.theme.colors.outline.default};
  }

  ${props =>
    props.active &&
    css`
      background-color: ${props.theme.colors.outline.default};
      border-color: ${props.theme.colors.outline.default};

      & > p:first-of-type {
        color: ${props.theme.colors.text.inverse};
      }

      & > p:last-of-type {
        color: ${props.theme.colors.text.subtle};
      }

      &:hover {
        border-color: ${props.theme.colors.outline.default};
      }
    `}
`
